import { render, staticRenderFns } from "./ReturnProductTable.vue?vue&type=template&id=3ea1e60a&scoped=true&"
import script from "./ReturnProductTable.vue?vue&type=script&lang=js&"
export * from "./ReturnProductTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea1e60a",
  null
  
)

export default component.exports